import React from 'react';

/**
 * Checks if the video url is allowed for the Video Embed
 * Currently only Wistia videos are allowed
 *
 * @param videoUrl {?string}
 * @returns {boolean}
 */
const videoIsAllowed = (videoUrl) => {
  if (!videoUrl) {
    return false;
  }

  return videoUrl.includes('fast.wistia.net/embed');
};

const VideoEmbed = ({ videoUrl }) => {
  if (!videoIsAllowed(videoUrl)) {
    return null;
  }

  return (
    <div
      style={{
        width: '100%',
        display: 'inline-block',
        position: 'relative',
        marginBottom: '12px',
        marginTop: '12px',
        marginLeft: 'auto',
        marginRight: 'auto',
      }}
    >
      <iframe
        title="Wistia video player"
        allowFullScreen
        frameBorder="0"
        scrolling="no"
        className="wistia_embed"
        name="wistia_embed"
        src={videoUrl}
        style={{
          position: 'absolute',
          top: '0',
          left: '0',
          width: '100%',
          height: '100%',
        }}
      />
      <div
        style={{
          /**
           * This part is responsible for the aspect ratio of the video
           * 56.25% is the aspect ratio of 16:9
           *
           * other aspect ratios are:
           * 75% - 4:3
           * 66.6% - 3:2
           * 62.5% - 8:5
           */
          paddingTop: '56.25%',
          display: 'block',
          pointerEvents: 'none',
          opacity: 0,
        }}
      />
    </div>
  );
};

export default VideoEmbed;
